import { render, staticRenderFns } from "./home-kpi.vue?vue&type=template&id=32e1b2ba&scoped=true"
import script from "./home-kpi.vue?vue&type=script&lang=js"
export * from "./home-kpi.vue?vue&type=script&lang=js"
import style0 from "./home-kpi.vue?vue&type=style&index=0&id=32e1b2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1b2ba",
  null
  
)

export default component.exports